function showFiltersOnMobile() {
  const btnOpen = document.querySelector('.activate-sidemenu-mobile');
  const btnClose = document.querySelector('.programming2020Container__sidemenu__close');
  const sideMenu = document.querySelector('.programming2020Container__sidemenu');
  const btnSearch = document.querySelector('.programming2020Container__sidemenu__search__btn');
  const btnFilter = document.querySelector('.programming2020Container__sidemenu__btn');

  function removeActive() {
    sideMenu.classList.remove('programming2020Container__sidemenu--active');
  }

  function addActive() {
    sideMenu.classList.add('programming2020Container__sidemenu--active');
  }

  if (btnOpen) {
    btnOpen.addEventListener('click', addActive);
  }

  if (btnClose) {
  btnClose.addEventListener('click', removeActive);
  }

  if (btnSearch) {
  btnSearch.addEventListener('click', removeActive);
  }

  if (btnFilter) {
    btnFilter.addEventListener('click', removeActive);
  }
}

window.addEventListener("load", showFiltersOnMobile);
